var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-hidden lg:tw-flex tw-ml-8"},[_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('span',{staticClass:"brand-logo"},[_c('b-img',{staticClass:"tw-h-7",attrs:{"src":_vm.appLogoImage,"alt":"logo"}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }